import type { ChecksResp, SummaryResp } from "./types";

// 개발: package.json proxy 사용 (/api/v1)
// 프로덕션: 환경변수에서 절대 URL 읽기
const API_BASE = process.env.REACT_APP_API_BASE_URL || "/api/v1";

async function getJSON<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { Accept: "application/json" },
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} ${res.statusText}: ${txt}`);
  }
  return res.json() as Promise<T>;
}

export const api = {
  summary: () => getJSON<SummaryResp>("/summary"),
  checks: (endpointId: number, limit = 40) =>
    getJSON<ChecksResp>(`/checks?endpoint_id=${endpointId}&limit=${limit}`),
};
